export class StoreToken {
  static IStoreRepository = Symbol("IStoreRepository");
  static StoreUseCase = Symbol("StoreUseCase");
  static StoreViewModel = Symbol("StoreViewModel");
}
